import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import styled from 'styled-components';
import { spacing1x } from '../../../../styles/spacing.js';
import { getColorWithOpacity } from '../../../../utils/color.js';
import { TREE_DRAG_ANIM_TIME, TREE_DRAG_ANIM_CURVE, TREE_DEFAULT_BORDER_WIDTH } from '../../constants.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children"];
var Container = styled.div.withConfig({
  displayName: "TreeDropBar__Container",
  componentId: "sc-hn111g-0"
})(function (_ref) {
  var isDragOver = _ref.isDragOver;
  return {
    position: "relative",
    opacity: isDragOver ? 1 : 0,
    height: isDragOver ? "36px" : "0",
    transition: "height ".concat(TREE_DRAG_ANIM_TIME, " ").concat(TREE_DRAG_ANIM_CURVE, ", opacity 0.25s ").concat(TREE_DRAG_ANIM_CURVE),
    zIndex: 3
  };
});
var DroppableRegion = styled.div.withConfig({
  displayName: "TreeDropBar__DroppableRegion",
  componentId: "sc-hn111g-1"
})(["&&{top:-8px;opacity:1;position:absolute;height:100%;min-height:15px;width:100%;}"]);
var Placeholder = styled.div.withConfig({
  displayName: "TreeDropBar__Placeholder",
  componentId: "sc-hn111g-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return {
    position: "absolute",
    height: "36px",
    width: "100%",
    backgroundColor: getColorWithOpacity(theme.CTAColors.primary, 0.1),
    border: "".concat(TREE_DEFAULT_BORDER_WIDTH, "px dotted ").concat(theme.CTAColors.primary),
    borderRadius: spacing1x,
    zIndex: 0,
    pointerEvents: "none"
  };
});
var TreeDropBar = function TreeDropBar(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/jsxs(Container, {
    isDragOver: props.isDragOver,
    children: [/*#__PURE__*/jsx(DroppableRegion, {
      ref: props.dndRef,
      children: children
    }), props.isDragOver && /*#__PURE__*/jsx(Placeholder, {})]
  });
};

export { TreeDropBar };
